/**
 * Created by bear on 17/07/06.
 * SDK入口
 */
import './polyfill'
import '../conf/sdk-common-conf'
import modules from './modules'
import util from './util'
import ui from './ui/ui'

// 初始化SDK数据环境
util.initPage()

const f2eGame = (window.f2eGame = {
  // 工具类
  util,

  // 接口类
  port: {
    ...modules
  },

  ui
})

export default f2eGame
